module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-ca2f5ed4.png";